import { render, staticRenderFns } from "./ChatUser.vue?vue&type=template&id=156eb7de&scoped=true&"
import script from "./ChatUser.vue?vue&type=script&lang=js&"
export * from "./ChatUser.vue?vue&type=script&lang=js&"
import style0 from "./ChatUser.vue?vue&type=style&index=0&id=156eb7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156eb7de",
  null
  
)

export default component.exports